import { styled, InputBase, FormLabel } from '@mui/material';

export const FileInput = styled(InputBase)({
  display: 'none',
});

export const FileInputLabel = styled(FormLabel)({
  maxWidth: 'max-content',
});
